import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarLightReachCommand } from "./solar-lightreach-cache"
import type { SolarLightReachDto } from "../dto/solar-lightreach.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Get LightReach pricing: the server ensures the account, pushes the utility
 * and design, and stores LightReach's offers. A selection made under the old
 * offers may read stale after it, so every price reader refetches. A failure
 * may still have stored offers, so it reads them again.
 */
export default function useGetSolarLightReachPricing(): UseMutationResult<
  SolarLightReachDto,
  unknown,
  { proposalId: string }
> {
  return useSolarLightReachCommand(
    ({ proposalId }) => solarProposalService.getLightReachPricing(proposalId),
    `pricing`,
  )
}
